import React from "react";
import { Helmet } from "react-helmet-async";
import Header from "../componentsProyectum/Header";
import BarraApp from "../componentsPeopletech/Barraaps"; // Asegúrate de que sea el nombre correcto
import Footer from "../componentsProyectum/Footer/Footer";

const HomeProyectum = () => {
  const baseUrl = "https://www.peoplefortech.com";
  const pageUrl = `${baseUrl}/proyectum/home`;

  return (
    <>
      <Helmet>
        <title>Proyectum - PeopleForTech</title>
        <meta name="description" content="Proyectum page for internal/archived content." />
        <meta name="robots" content="noindex,follow" />
        <link rel="canonical" href={pageUrl} />
      </Helmet>
      <BarraApp />
      <Header /> {/* Componente de encabezado */}
      <Footer />
    </>
  );
};

export default HomeProyectum;
